import { useState } from 'react';
import { ChatText, X } from '@phosphor-icons/react';
import { RichEditor } from './RichEditor';

type Props = {
  value: string;
  onChange: (value: string) => void;
  onPost: () => void;
  disabled?: boolean;
  disabledReason?: string;
};

export function StickyCommentBar({ value, onChange, onPost, disabled, disabledReason }: Props) {
  const [expanded, setExpanded] = useState(false);
  const isEmpty = !value.trim();

  if (!expanded) {
    return (
      <div className="border-t border-stone-200 bg-stone-100 px-4 py-3">
        <button
          type="button"
          onClick={() => !disabled && setExpanded(true)}
          disabled={disabled}
          title={disabled ? disabledReason : ''}
          className="w-full text-left bg-white border border-stone-300 rounded px-3 py-2 text-sm text-stone-400 cursor-text hover:border-stone-400 disabled:bg-stone-50 disabled:cursor-not-allowed disabled:hover:border-stone-300"
        >
          Agregar un comentario...
        </button>
      </div>
    );
  }

  return (
    <div className="border-t border-stone-200 bg-stone-100 px-4 py-3">
      <RichEditor value={value} onChange={onChange} autoFocus />
      <div className="flex justify-end gap-2 mt-2">
        <button
          type="button"
          onClick={() => { onChange(''); setExpanded(false); }}
          className="px-3 py-1.5 text-xs border border-stone-300 rounded hover:bg-stone-50 flex items-center gap-1"
        >
          <X size={12} weight="bold" /> Cancelar
        </button>
        <button
          type="button"
          onClick={() => { onPost(); setExpanded(false); }}
          disabled={isEmpty || disabled}
          title={disabled ? disabledReason : ''}
          className="px-3 py-1.5 text-xs bg-brand-gray-500 text-white rounded hover:bg-brand-gray-400 flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChatText size={12} weight="bold" /> Comentar
        </button>
      </div>
    </div>
  );
}
